import { ExtendableError } from "../../common";

export class MixerInvalidRtmpPipeError extends ExtendableError {
  constructor(mixerId: string) {
    super(`Mixer ${mixerId} Invalid Rtmp Pipe Error`);
  }
}
